import { useCallback, useEffect, useState } from "react";
import { BiCategory } from "react-icons/bi";
import { BsChatFill } from "react-icons/bs";
import { FaHome, FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { toogleChat } from "../../Redux/reducers/chatSlice";
import MenuPop from "../Common/Menu/MenuPop";
import "./StickyNav.css";
const StickyNav = ({ logout, setLoginOpen, setShowChat, showChat, badge }) => {
  const user = useSelector((state) => state.user.user);
  const [showMenu, setShowMenu] = useState(false);
  const [isNavClicked, setIsNavClicked] = useState(false);
  const [y, setY] = useState(window.scrollY);
  const [isScrollUp, setIsScrollUp] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.pathname === "/users/myaccount") {
      setIsNavClicked(true);
    }
  }, []);

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y > window.scrollY) {
        setIsScrollUp(true);
      } else if (y < window.scrollY) {
        setIsScrollUp(false);
      }
      setY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  const menuStyle1 = {
    transition: "0.5s all",
    transform: showMenu ? "translateX(0)" : "translateX(100%)",
  };
  const menuStyle2 = {
    transition: "0.5s all",
    transform: showMenu ? "translateX(0)" : "translateX(-100%)",
  };
  const menuStyle3 = {
    transition: "0.5s all",
    transform: showMenu ? "translateY(0)" : "translateY(600%)",
  };

  return (
    <div
      className={`sticky-nav ${isScrollUp ? "" : ""}`}
      style={{ zIndex: 999 }}
    >
      <NavLink
        onClick={() => {
          setIsNavClicked(false);
        }}
        activeclassname="active"
        to="/"
        className="sticky-nav-item"
      >
        <FaHome size={20} className="icon" />
        <p className="mt-1 nav-text">Home</p>
      </NavLink>
      <NavLink
        onClick={() => {
          setIsNavClicked(false);
        }}
        activeclassname="active"
        to="/categories"
        className="sticky-nav-item"
      >
        <BiCategory size={20} className="icon" />
        <p className="mt-1 nav-text">Category</p>
      </NavLink>
      {/* <NavLink
        onClick={() => {
          setIsNavClicked(false);
        }}
        activeclassname="active"
        to="/products"
        className="sticky-nav-item"
      >
        <FaProductHunt size={20} className="icon" />
        <p className="mt-1 nav-text">Products</p>
      </NavLink> */}
      {user && (
        <div
          onClick={() => {
            setIsNavClicked(false);
            dispatch(toogleChat());
          }}
          className={`sticky-nav-item ${showChat && "active"
            } position-relative`}
        >
          {badge !== 0 && (
            <div
              className="bg-danger d-flex justify-content-center align-items-center text-white px-2 py-1 position-absolute translate-middle"
              style={{
                top: 3,
                right: -15,
                width: "auto",
                borderRadius: "50%",
              }}
            >
              <h6
                className="mb-0"
                style={{
                  fontSize: "12px",
                }}
              >
                {badge}
              </h6>
            </div>
          )}

          <BsChatFill size={20} className="icon" />
          <p className="mt-1 nav-text">Chat</p>
        </div>
      )}

      {user !== null ? (
        <div className="sticky-nav-item">
          <div style={{ position: "relative" }}>
            <div
              style={{ overflow: "hidden" }}
              className=" text-decoration-none text-dark "
            >
              <div
                className={`sticky-nav-item ${isNavClicked ? "active" : ""}`}
                onClick={() => {
                  setShowMenu(!showMenu);
                }}
              >
                <FaUser size={20} className="icon" />
                <p className="mt-1 nav-text">User</p>
              </div>

              <MenuPop
                logout={logout}
                bottom={80}
                hoverWidth={20}
                menuStyle1={menuStyle1}
                menuStyle2={menuStyle2}
                menuStyle3={menuStyle3}
                showMenu={showMenu}
                setShowMenu={() => {
                  setShowMenu(false);
                }}
                user={user}
              />
            </div>
          </div>
          {/* <Dropdown className='me-2 my-auto' drop="up">
                        <Dropdown.Toggle style={{ boxShadow: "none" }} className='bg-transparent border-0 text-dark'>
                            <div className='sticky-nav-item'>
                                <FaUser size={20} />
                                <p className='mt-1'>User</p>
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item> <Link className='text-decoration-none text-black' to='/users/myaccount'>My Account</Link></Dropdown.Item>
                            <Dropdown.Item onClick={() => { logout(); }}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
        </div>
      ) : (
        <div className="sticky-nav-item" onClick={setLoginOpen}>
          <FaUser size={20} />
          <p className="mt-1">Login</p>
        </div>
      )}
    </div>
  );
};

export default StickyNav;
